/**
 * FilterTabs Component - Uses shadcn/ui Tabs
 */
import { memo } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

interface FilterTab {
  key: string;
  label: string;
  count?: number;
}

interface FilterTabsProps {
  filters: FilterTab[];
  activeFilter: string;
  onFilterChange: (value: string) => void;
  className?: string;
}

const FilterTabs = memo(({
  filters,
  activeFilter,
  onFilterChange,
  className = ""
}: FilterTabsProps) => {
  return (
    <Tabs value={activeFilter} onValueChange={onFilterChange} className={cn("w-full", className)}>
      <TabsList className="flex items-center space-x-2 overflow-x-auto">
        {filters.map(({ key, label, count }) => (
          <TabsTrigger 
            key={key} 
            value={key}
            className="whitespace-nowrap"
          >
            {label} {count !== undefined && `(${count})`}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
});

FilterTabs.displayName = 'FilterTabs';

export default FilterTabs;
